import React from 'react'
import injectStyles from 'react-jss'
import classnames from 'classnames'

import Form, { SelectDashboard } from '../../../../../../Components/Form'
import { styles } from './styles'

const ChartHeader = ({
  statsOptions,
  classes,
  handleFormChange,
  selectOptions,
  selectedValue,
}) => (
  <div className={classes.wrapper}>
    {statsOptions.map(item => (
      <div className={classes.itemWrapper}>
        <div className={classes.title}>{item.title}</div>
        <div className={classes.value}>{item.value}</div>
        <div className={classnames(classes.diff, { 'green': item.isPositive })}>
          {item.isPositive ? '▲' : '▼'} {item.diff.toFixed()}%
        </div>
      </div>
    ))}
    <div className={classes.select}>
      <Form onUpdate={handleFormChange}>
        <SelectDashboard
          bgTransparent
          heightAuto
          options={selectOptions}
          value={selectedValue}
          name="rangeByDate"
        />
      </Form>
    </div>
  </div>
)

export default injectStyles(styles)(ChartHeader)



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/CampaignPerforming/Charts/ChartHeader/index.js